// TODO - Type 'any' needs to be fixed.
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { Box, Typography } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";

import colors from "../../../../../../../config/colors";
import SkillLevelDropdown from "../../../../../../../design/skill-level-dropdown";
import useOnView from "../../../../../../../utils/use-on-view";
import useWorkersData from "../../../../../controllers/use-workers-data";
import { distinctElements } from "../../../../helper";

const icon = <CheckBoxOutlineBlankIcon fontSize='small' />;
const checkedIcon = <CheckBoxIcon fontSize='small' />;

type AssignOtherSkillsProps = {
	workerAssignedSkills: number[];
	handleNewAssignedSkills?: (skillId: number, level: number | string) => void;
	newAssignedSkills?: any[];
	skillsMappedWithJob?: number[];
	removeMultipleSkills?: (skillIds: number[]) => void;
};

const AssignOtherSkills = ({
	workerAssignedSkills,
	handleNewAssignedSkills,
	newAssignedSkills,
	skillsMappedWithJob,
	removeMultipleSkills,
}: AssignOtherSkillsProps) => {
	const { t } = useTranslation();
	const [value, setValue] = React.useState<any[] | null>([]);

	const ref = useRef<HTMLDivElement>(null);
	const isIntersecting = useOnView(ref);

	const { allSkills, allSkillLevels, obsoleteSkills } = useWorkersData();

	React.useEffect(() => {
		if (newAssignedSkills && allSkills.length > 0) {
			const otherSkills = newAssignedSkills
				.filter((s) => !skillsMappedWithJob?.includes(s.skillId))
				.map((s) => allSkills.find((skill: any) => skill.id === s.skillId))
				.filter((s) => !!s);
			setValue(otherSkills);
		}
	}, [newAssignedSkills, allSkills, skillsMappedWithJob]);

	const unassignedSkills = allSkills.filter(
		(skill: any) =>
			!workerAssignedSkills?.includes(skill.id) &&
			!skillsMappedWithJob?.includes(skill.id) &&
			!obsoleteSkills?.includes(skill.id)
	);

	const removeSkill = (skillId: number) => {
		removeMultipleSkills?.([skillId]);
	};

	return (
		<Box mt={2} mb={2}>
			<Box display='flex' alignItems='center'>
				<Box width={200}>
					{" "}
					<Typography
						sx={{
							fontFamily: "Roboto",
							fontWeight: 500,
							fontSize: "14px",
							color: "#000000",
							lineHeight: "24px",
							letterSpacing: "0.17px",
						}}
					>
						{t("workers_additional-skills")}
					</Typography>
				</Box>
				<Box ml={1} ref={ref}>
					<Autocomplete
						value={value ? value : []}
						multiple
						id='tags-filled'
						options={unassignedSkills}
						getOptionLabel={(option: string | { name: string }) => {
							if (typeof option === "string") {
								return option;
							}
							return option.name;
						}}
						renderOption={(props, option: string | { name: string }, { selected }) => {
							if (!isIntersecting) return null;
              if (typeof option === "string") {
                return <li {...props}>{option}</li>;
              }
							return (
								<li {...props}>
									<Checkbox
										icon={icon}
										checkedIcon={checkedIcon}
										style={{ marginRight: 8 }}
										checked={selected}
									/>
									{option.name}
								</li>
							);
						}}
						onChange={(event, newValue, reason) => {
							if (reason === "selectOption") {
								const newlySelected = distinctElements(newValue, value || [], "id");
								newlySelected.forEach(skill => handleNewAssignedSkills?.(skill.id, ""));
								return;
							} else if (reason === "removeOption") {
								const removedItem = distinctElements(value || [], newValue, "id");
								removeMultipleSkills?.(removedItem.map((item) => item.id));
								return;
							}
						}}
						disableCloseOnSelect
						renderTags={(value: any, getTagProps) => <></>}
						renderInput={(params) => (
							<TextField
								{...params}
								variant='outlined'
								label={t("workers_select-skills")}
							/>
						)}
						onInputChange={(e, v, reason) => {
							if (reason === "clear") {
								const commonElements =
									newAssignedSkills?.filter((item1) =>
										value?.some((item2) => item1.skillId === item2.id)
									) || [];
								removeMultipleSkills?.(
									commonElements.map((item) => item.skillId)
								);
								return;
							}
						}}
						sx={{ width: 560 }}
						componentsProps={{
							popper: {
								style: {
									width: 560,
									display: isIntersecting ? "block" : "none",
								},
							},
						}}
					/>
				</Box>
			</Box>
			<Box
			sx={{
				display: "grid",
				gridTemplateColumns: "1fr 1fr",
				mt: 1,
			}}>
				{value?.map((skill: any) => (
					<Box key={skill.id} mr={1} mt={1} mb={1}>
						<SkillLevelDropdown
							allSkillLevels={allSkillLevels}
							skillName={skill.name}
							skillId={skill.id}
							handleSkill={handleNewAssignedSkills}
							newAssignedSkills={newAssignedSkills}
							removeSkill={removeSkill}
						/>
					</Box>
				))}
			</Box>
		</Box>
	);
};

export default AssignOtherSkills;
